import { render } from "./CalculationPreview.vue?vue&type=template&id=3680d403&scoped=true"
import script from "./CalculationPreview.vue?vue&type=script&lang=ts"
export * from "./CalculationPreview.vue?vue&type=script&lang=ts"

import "./CalculationPreview.vue?vue&type=style&index=0&id=3680d403&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3680d403"

export default script